import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const ModulesService = {
    modulesOptions: async () => axios.get(API_URL + "/modules/options").then(({data}) => data).catch((err) => { throw  err}),
    modulesOptionsIdValue: async () => axios.get(API_URL + "/modules/options-id-value").then(({data}) => data).catch((err) => { throw  err}),
};

export default ModulesService;